import Header from '@components/Bundling/Header'
import OuterWrapper from '@components/Bundling/OuterWrapper'
import MainItemWrapper from '@components/Bundling/MainItemWrapper'
import RelatedItemsWrapper from '@components/Bundling/RelatedItemsWrapper'
import RelatedItemsSidebarWrapper from '@components/Bundling/RelatedItemsSidebarWrapper'

const exports = {
  Header,
  OuterWrapper,
  MainItemWrapper,
  RelatedItemsWrapper,
  RelatedItemsSidebarWrapper,
}

export default exports
